import { ArrowRight } from 'lucide-react'
import { Badge } from '@/components/ui/Badge'
import type { Finding, Severity } from '../lib/run-diagnostics'

function severityTone(s: Severity): 'danger' | 'warning' | 'neutral' {
  if (s === 'ALTA') return 'danger'
  if (s === 'MEDIA') return 'warning'
  return 'neutral'
}

const SEVERITY_LABEL: Record<Severity, string> = {
  ALTA: 'Prioridade alta',
  MEDIA: 'Prioridade média',
  BAIXA: 'Prioridade baixa',
}

function MetaLine({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex gap-2 text-xs">
      <span className="shrink-0 w-20 text-fg-3">{label}</span>
      <span className="text-fg-2">{value}</span>
    </div>
  )
}

export function FindingCard({ finding }: { finding: Finding }) {
  return (
    <div className="rounded-lg border border-border-subtle bg-bg-surface p-4 transition-colors hover:border-border-strong">
      <div className="flex items-start justify-between gap-3 mb-2.5">
        <h4 className="text-sm font-semibold text-fg-1 leading-snug">{finding.problem}</h4>
        <Badge tone={severityTone(finding.severity)}>{SEVERITY_LABEL[finding.severity]}</Badge>
      </div>
      <div className="flex flex-col gap-1.5">
        <MetaLine label="Evidência" value={finding.evidence} />
        <MetaLine label="Impacto" value={finding.impact} />
        <div className="flex gap-2 text-xs">
          <span className="shrink-0 w-20 text-fg-3">Ação</span>
          <span className="inline-flex items-start gap-1.5 text-brand-700 font-medium">
            <ArrowRight className="h-3.5 w-3.5 mt-0.5 shrink-0" />
            {finding.action}
          </span>
        </div>
      </div>
    </div>
  )
}
